import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import projectQueries from "../../../../requests/queries/ProjectsQuesries";
import screenSizeQueries from "../../../../requests/queries/screenSizeQueries";
import "./createProject.css";

export default function CreateProject() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        screen_size_id: "",
    });
    const [screenSizes, setScreenSizes] = useState([]);

    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchScreenSizes = async () => {
            const screenSizes = await screenSizeQueries.getAll();
            setScreenSizes(screenSizes);
        };
        fetchScreenSizes();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await projectQueries.createProject(formData.name, formData.description, formData.screen_size_id);
            navigate('/projects');
        } catch (error) {
            setError(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="create-project-page">
            <div className="grid-bg"></div>
            
            <Link to="/projects" className="cp-back-link">
                ← Retour aux projets
            </Link>

            <div className="create-project-card">
                <div className="create-project-header">
                    <div className="create-project-icon">🚀</div>
                    <h1 className="create-project-title">Nouveau projet</h1>
                    <p className="create-project-subtitle">
                        Configurez votre nouveau projet de borne interactive
                    </p>
                </div>

                <div className="create-project-body">
                    <form className="create-project-form" onSubmit={handleSubmit}>
                        {error && <div className="cp-error">{error}</div>}
                        <div className="cp-input-group">
                            <label className="cp-label" htmlFor="name">
                                <span className="cp-label-icon">📝</span>
                                Nom du projet
                            </label>
                            <input
                                id="name"
                                className="cp-input"
                                type="text"
                                name="name"
                                placeholder="Ex: Borne Accueil Principal"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="cp-input-group">
                            <label className="cp-label" htmlFor="description">
                                <span className="cp-label-icon">📄</span>
                                Description
                            </label>
                            <textarea
                                id="description"
                                className="cp-input cp-textarea"
                                name="description"
                                placeholder="Décrivez brièvement le but de ce projet..."
                                value={formData.description}
                                onChange={handleChange}
                            />
                            <p className="cp-hint">Optionnel - Ajoutez des détails pour identifier ce projet</p>
                        </div>

                        <div className="cp-input-group">
                            <label className="cp-label" htmlFor="screen_size_id">
                                <span className="cp-label-icon">🖥️</span>
                                Taille d'écran
                            </label>
                            <select
                                id="screen_size_id"
                                className="cp-select"
                                name="screen_size_id"
                                value={formData.screen_size_id}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Sélectionnez une taille</option>
                                {
                                    screenSizes.map((screenSize) => (
                                        <option key={screenSize.id} value={screenSize.id}>{screenSize.width} × {screenSize.height} ({screenSize.ratio_x}:{screenSize.ratio_y})</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="create-project-actions">
                            <Link to="/projects" className="cp-btn cp-btn-secondary">
                                Annuler
                            </Link>
                            <button 
                                type="submit" 
                                className={`cp-btn cp-btn-primary ${isLoading ? 'loading' : ''}`}
                                disabled={isLoading}
                            >
                                <span>Créer le projet ✨</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
